import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SnoopMappingPage from './SnoopMappingPage';
import LuminateMappingPage from './LuminateMappingPage';
import PLineMappingPage from './PLineMappingPage';

/**
 * The mapping suite: the tables that decide what the discovery feeds show.
 * Mirrors the coworker dashboard's Mapping nav, which keeps these separate
 * from the Unsigned (discovery) suite rather than mixing them in.
 *
 * Artist and Sound mapping live upstream too but were not part of this port,
 * so they are absent here rather than stubbed.
 *
 * Each view has its own URL, so selecting one is a real navigation: deep links,
 * reloads, the back button and shared links all behave the same way.
 */
const VIEWS = [
  { id: 'snoop', label: 'Snoop', path: '/mapping/snoop', Component: SnoopMappingPage },
  { id: 'p-line', label: 'P-line', path: '/mapping/p-line', Component: PLineMappingPage },
  { id: 'luminate', label: 'Luminate', path: '/mapping/luminate', Component: LuminateMappingPage },
];

export default function MappingPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // The path is the source of truth: /mapping bare redirects to /mapping/snoop,
  // so a ?view= param would be dropped before this component ever saw it.
  const byPath = VIEWS.find((v) => location.pathname.startsWith(v.path));
  const active = byPath?.id || 'snoop';

  const setActive = (next) => {
    const view = VIEWS.find((v) => v.id === next);
    if (view && view.path !== location.pathname) navigate(view.path);
  };

  const Active = (VIEWS.find((v) => v.id === active) || VIEWS[0]).Component;

  return (
    <div>
      <div className="mb-3 flex flex-wrap items-center gap-1.5">
        {VIEWS.map((view) => (
          <button
            key={view.id}
            type="button"
            onClick={() => setActive(view.id)}
            className={`rounded-full px-3 py-1.5 text-sm font-medium transition-colors ${
              active === view.id
                ? 'bg-red-600 text-white'
                : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
            }`}
          >
            {view.label}
          </button>
        ))}
      </div>
      <Active />
    </div>
  );
}
